import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import { Button, BUTTON_COLOR, Loader, Row } from "taltech-styleguide";
import { configSettings } from "../../../configuration/ConfigurationSettings";
import { AuthPageBackground } from "./AuthPageBackground";
import {
  useSession,
  useUserContext,
} from "../../../_runtime/iam/session.context";
import { application } from "../../../_runtime/bootstrap";

/**
 * Functional Component: LoginScreen
 * 
 * This component manages the login process using Microsoft Authentication Library (MSAL).
 * It checks for an existing login session and handles redirects or login prompts as necessary.
 * 
 * Returns:
 * @returns {JSX.Element} A JSX element displaying the login screen.
 */
const LoginScreen: React.FC<any> = () => {
  const sessionContext = useSession();
  const { scopes } = configSettings.authentication.options.auth;
  const popupRequest = { scopes };
  const { instance } = useMsal();
  const { role } = useUserContext();
  instance.handleRedirectPromise().then((x: any) => {
    if (
      x !== null &&
      !instance.getActiveAccount() &&
      instance.getAllAccounts().length > 0
    ) {
      application.getHttpClient().get("usersms/users/self/verification");
      instance.setActiveAccount(instance.getAllAccounts()[0]);
      sessionContext.handleLoginSuccess(x);
    }
  });
  const handleLogin = (loginType: string) => {
    instance.loginRedirect(popupRequest);
  };

  return (
    <AuthPageBackground>
      <AuthenticatedTemplate>
        {role === undefined ? (
          <Loader overlay />
        ) : (
          <Navigate to={sessionContext.getRouteBasedOnRole()} />
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Row>
          <h1>Login</h1>
          <p>Using your University account credentials</p>
        </Row>
        <Row className="justify-content-center">
          <Button
            className="col-6"
            variant={BUTTON_COLOR.SECONDARY}
            size="lg"
            onClick={() => {
              handleLogin("popup");
            }}
          >
            Login
          </Button>
        </Row>
      </UnauthenticatedTemplate>
    </AuthPageBackground>
  );
};

export default LoginScreen;
